module.exports = __webpack_public_path__ + "img/Flexible Character.3df7c95c.svg";